
import type { SVGProps } from 'react';
const SvgWatchlist = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={23}
    fill="none"
    {...props}
  >
    <g clipPath="url(#watchlist_svg__a)">
      <path
        fill="#263E6A"
        d="M19.1 22.6a.6.6 0 0 1-.28-.072l-6.814-3.539h-.012L5.18 22.53a.55.55 0 0 1-.581-.025.53.53 0 0 1-.203-.539l1.302-7.496-.004-.011L.18 9.149a.53.53 0 0 1-.156-.553.54.54 0 0 1 .456-.357l7.618-1.094.01-.007 3.407-6.82c.1-.2.28-.318.484-.318s.385.119.485.318l3.407 6.82.01.007 7.617 1.094a.54.54 0 0 1 .456.357.53.53 0 0 1-.157.553l-5.511 5.31-.004.01 1.301 7.497a.53.53 0 0 1-.203.538.5.5 0 0 1-.3.096M12 18.133c.14 0 .278.03.394.09l6.244 3.244-1.193-6.87a.88.88 0 0 1 .243-.74l5.052-4.865L15.76 7.99a.9.9 0 0 1-.637-.457L12 1.283l-3.122 6.25a.9.9 0 0 1-.637.457L1.26 8.992l5.052 4.865c.187.18.287.485.243.74l-1.193 6.87 6.244-3.244a.9.9 0 0 1 .394-.09M12.293.696"
      />
    </g>
    <defs>
      <clipPath id="watchlist_svg__a">
        <path fill="#fff" d="M0 0h24v23H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWatchlist;
